import { useEffect } from 'react';

/**
 * 모바일 브라우저에서 input 요소에 포커스(focus)할 때, 화면이 자동으로 스크롤(확대)되는 현상을 억제
 * 모든 input 요소의 'focus' 이벤트를 감지하여, 포커스 직후에 window.scrollTo(0, 0)를 호출해 스크롤을 맨 위로 되돌림
 */
const usePreventInputScroll = () => {
    useEffect(() => {
        const handleFocus = () => {
            // 브라우저의 자동 스크롤 동작 직후에 스크롤을 맨 위로 되돌림
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 100); // 약간의 딜레이를 주어 안정적으로 동작하도록 함
        };

        // 모든 input 요소에 focus 이벤트 리스너 추가
        const inputs = document.querySelectorAll('input');
        inputs.forEach(input => input.addEventListener('focus', handleFocus));

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            inputs.forEach(input => input.removeEventListener('focus', handleFocus));
        };
    }, []);
};

export default usePreventInputScroll;